import { notificationTypes } from '@/helpers/enums';
import store from '@/store';

export const notificationOptions = {
	icon: '/logo.png',
	dir: 'rtl',
	lang: 'ar-SA',
};

export const notificationPageRedirect = [
	{ type: notificationTypes.message, redirect: '/chat', routeName: 'chat' },
	{ type: notificationTypes.attendance, redirect: '/attendance', routeName: 'attendance' },
	{ type: notificationTypes.newMark, redirect: '/grades', routeName: 'grades' },
	{ type: notificationTypes.newMarks, redirect: '/grades', routeName: 'grades' },
	{ type: notificationTypes.schedule, redirect: '/schedule', routeName: 'schedule' },
	{ type: notificationTypes.newTest, redirect: '/exams', routeName: 'exams' },
	{ type: notificationTypes.testsSchedule, redirect: '/exams', routeName: 'exams' },
	{ type: notificationTypes.transport, redirect: '/', routeName: 'home' },
	{ type: notificationTypes.notes, redirect: '/behavior', routeName: 'behavior' },
];

export const firebase = {
	configs: {
		apiKey: 'AIzaSyC-SAtiDN_KShksgdX6rnF3kfYX28O9cnc',
		authDomain: 'shams-alasel-app.firebaseapp.com',
		projectId: 'shams-alasel-app',
		storageBucket: 'shams-alasel-app.appspot.com',
		messagingSenderId: '486700478076',
		appId: '1:486700478076:web:b3d800d2c9ada4dcb863f9'	  
	},
	publicKey: 'BMstzJOMtPYOsorPXifQs3n_3LOuqy2bwyU8U_AmdSQcrRGR6iE305ZYwDu8IStL3I3B4fPkwtgcUzeCMRBnvcs',
};

export const onGetNotification = () => {
	store.dispatch('notification/fetchAll');
};
